import { createSlice } from '@reduxjs/toolkit';

export const categoriesSlice = createSlice({
	name: 'categories',
	initialState: { data: [] },
	reducers: {
		addCategories: function (state, action) {
			state.data = action.payload;
		},
	},
});

export const { addCategories } = categoriesSlice.actions;
export default categoriesSlice.reducer;
